import React from 'react';
import { Container, Typography, Paper, Box, Divider, Link } from '@mui/material';
import Seo from '../../Components/Seo';

const PrivacyPolicy = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Seo
                title="Privacy Policy"
                description="Privacy Policy for Radiology Illustration, including contact forms, analytics, cookies, and Google advertising disclosures."
                canonicalPath="/privacy-policy"
            />
            <Paper elevation={3} sx={{ p: { xs: 3, md: 5 } }}>
                <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 600 }}>
                    Privacy Policy
                </Typography>
                <Typography variant="subtitle1" align="center" color="text.secondary" gutterBottom>
                    Last updated: July 25, 2026
                </Typography>

                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
                        1. Introduction
                    </Typography>
                    <Typography paragraph>
                        Welcome to our website. We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and tell you about your privacy rights and how the law protects you.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
                        2. Information We Collect
                    </Typography>
                    <Typography paragraph>
                        We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:
                    </Typography>
                    <ul>
                        <li>
                            <Typography paragraph>
                                <strong>Identity Data</strong> includes first name, last name, username or similar identifier.
                            </Typography>
                        </li>
                        <li>
                            <Typography paragraph>
                                <strong>Contact Data</strong> includes email address and message content provided via our contact forms.
                            </Typography>
                        </li>
                        <li>
                            <Typography paragraph>
                                <strong>Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform and other technology on the devices you use to access this website.
                            </Typography>
                        </li>
                        <li>
                            <Typography paragraph>
                                <strong>Usage Data</strong> includes information about how you use our website, products and services.
                            </Typography>
                        </li>
                    </ul>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
                        3. How We Use Your Data
                    </Typography>
                    <Typography paragraph>
                        We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
                    </Typography>
                    <ul>
                        <li><Typography paragraph>To respond to your inquiries sent through our contact form.</Typography></li>
                        <li><Typography paragraph>To improve our website and services.</Typography></li>
                        <li><Typography paragraph>To detect and prevent technical issues.</Typography></li>
                    </ul>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
                        4. Cookies and Tracking Technologies
                    </Typography>
                    <Typography paragraph>
                        We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
                    </Typography>
                    <Typography paragraph>
                        We use Google AdSense to display ads on this site. Google uses cookies to serve ads based on your prior visits to our website or other websites. Google's use of advertising cookies enables it and its partners to serve ads to you based on your visit to our sites and/or other sites on the Internet.
                    </Typography>
                    <Typography paragraph>
                        Third parties, including Google, may place and read cookies on your browser or use web beacons, IP addresses, and similar identifiers as a result of ad serving, fraud prevention, measurement, and analytics. You can learn how Google uses information from sites and apps that use Google services at{' '}
                        <Link href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">
                            Google partner sites policy
                        </Link>.
                    </Typography>
                    <Typography paragraph>
                        We also use Google Analytics to understand aggregate site usage, such as visited pages, device type, and general traffic patterns. This helps us improve educational resources and site navigation.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
                        5. Third-Party Links
                    </Typography>
                    <Typography paragraph>
                        This website may include links to third-party websites, plug-ins and applications. Clicking on those links or enabling those connections may allow third parties to collect or share data about you. We do not control these third-party websites and are not responsible for their privacy statements.
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
                        6. Contact Us
                    </Typography>
                    <Typography paragraph>
                        If you have any questions about this privacy policy or our privacy practices, please contact us via the contact form on our home page.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default PrivacyPolicy;
